var map = {
	"./payex-logo-h.svg": 6301,
	"./payex-logo-neg.png": 31390,
	"./payex-logo-neg.svg": 14070,
	"./payex-logo-v.svg": 87205,
	"./payex-logo.png": 39991,
	"./payex-logo.svg": 28744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81479;